import { toRefs, ref, watch, unref, Ref, computed, nextTick } from 'vue-demi'
import { IComboBoxDataProps, IComboBoxEnumProps, IComboBoxProps, IComboBoxStandardProps } from './combobox.type'
import useComboBoxData from './useComboBoxData'
import useComboBoxEnum from './useComboBoxEnum'
import useComboBoxStandard from './useComboBoxStandard'
import { CHANGE_EVENT } from '@/components/utils/constants'

const useComboBox = (props: IComboBoxProps & Record<string, any>, { emit }: any) => {
  let comboBox: Record<string, any>
  const { loading, modelValue, multiple, valueField, forceSelection, multiline, remote } = toRefs(props)
  const loadingStatus = ref(loading.value)
  const select: Ref<any> = ref(null)
  let remoteMethod = null
  const onScroll = () => {}

  switch (props.type) {
    case 'enum':
      comboBox = useComboBoxEnum(props as IComboBoxEnumProps)
      break
    case 'data':
      comboBox = useComboBoxData(props as IComboBoxDataProps, loadingStatus, select)
      remoteMethod = comboBox.remoteMethod
      break
    default:
      comboBox = useComboBoxStandard(props as IComboBoxStandardProps)
  }

  /**
   * @description Lấy ra các bản ghi đã chọn
   * @author PHNam
   */
  const getSelectedRecords = () => {
    const field: string = valueField.value

    if (modelValue.value == null) { return }

    const storeItems = unref(comboBox.storeItems)

    if (!multiple.value) {
      const selectedValue = (modelValue as Ref<Record<string, any>>).value

      return storeItems.find((item: any) => item[field] === selectedValue)
    } else {
      const selected = Object.values((modelValue as Ref<Record<string, any>[]>).value)

      return storeItems.filter((item: Record<string, any>) => selected.includes(item[field]))
    }
  }

  /**
   * @description focus vào ô select
   * @author PHNam
   */
  const focus = () => {
    // eslint-disable-next-line no-unused-expressions
    select?.value?.focus()
  }

  /**
   * @description blur select
   * @author PHNam
   */
  const blur = () => {
    // eslint-disable-next-line no-unused-expressions
    select?.value?.blur()
  }

  /**
   * @description Cho phép filter
   * @author PHNam
   */
  const filterable = computed(() => {
    return remote?.value || !forceSelection.value
  })

  /**
   * @description Class của popper
   * @author PHNam
   */
  const popperClass = computed(() => {
    const popperCls = ['ms-popper']

    multiline.value && popperCls.push('multiline')

    return popperCls.join(' ')
  })

  /**
   * @description Xử lý khi change value của combobox
   * @param newVal
   * @authỏ PHNam
   */
  const onChange = async (newVal: any) => {
    await nextTick()
    emit(CHANGE_EVENT, newVal)
  }

  return { onScroll, ...comboBox, select, filterable, popperClass, loadingStatus, getSelectedRecords, focus, blur, onChange, remoteMethod }
}

export default useComboBox
